import api, { unwrap } from './client';
import type { ApiResponse } from '@/types/api';
import type {
  EnrichedApiResponse,
  UiDashboardWidget,
  UiFormSchema,
  UiMenuGroup,
  UiScreenActions,
  UiTableSchema,
  UiWorkflowContext,
} from '@/types/ui';

export const uiApi = {
  menus: (module?: string) =>
    unwrap(api.get<ApiResponse<UiMenuGroup[]>>('/v1/ui/menus', { params: module ? { module } : undefined })),

  screenActions: (path: string) =>
    unwrap(api.get<EnrichedApiResponse<UiScreenActions>>('/v1/ui/screens/actions', { params: { path } })),

  allScreenActions: () =>
    unwrap(api.get<ApiResponse<Record<string, UiScreenActions>>>('/v1/ui/screens/actions/all')),

  workflow: (ownerModule: string, entityType: string, entityId: number) =>
    unwrap(
      api.get<EnrichedApiResponse<UiWorkflowContext>>('/v1/ui/workflow', {
        params: { ownerModule, entityType, entityId },
      }),
    ),

  dashboardWidgets: (module?: string) =>
    unwrap(
      api.get<ApiResponse<UiDashboardWidget[]>>('/v1/ui/dashboard/widgets', {
        params: module ? { module } : undefined,
      }),
    ),

  formSchema: (screenId: string) =>
    unwrap(api.get<EnrichedApiResponse<UiFormSchema>>('/v1/ui/forms/schema', { params: { screenId } })),

  tableSchema: (screenId: string) =>
    unwrap(api.get<EnrichedApiResponse<UiTableSchema>>('/v1/ui/tables/schema', { params: { screenId } })),

  options: (type: string) =>
    unwrap(api.get<ApiResponse<Array<{ value: number | string; label: string; code?: string }>>>(
      '/v1/ui/options',
      { params: { type } },
    )),
};
